export default "__VITE_ASSET__D7pU_era__"